import hostedPBX from "public/application-services/icons/hosted-pbx.png";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_PBX_FEATURES = {
  title: "Features of Hosted Yeastar PBX ",
  list: [
    {
      image: hostedPBX,
      title: "Advanced Call Management",
      content: (
        <ContentCard
          points={[
            "Call routing & forwarding to direct calls efficiently.",
            "Auto-attendant for automated menu-based navigation.",
            "Voicemail-to-email for easy access and management.",
          ]}
        />
      ),
    },
    {
      image: hostedPBX,
      title: "Scalability, Flexibility & Cost Efficiency",
      content: (
        <ContentCard
          points={[
            "Easy expansion to add or remove extensions without major infrastructure changes.",
            "Remote accessibility for seamless communication from anywhere.",
            "Reduced capital & maintenance costs by eliminating on-site PBX hardware.",
          ]}
        />
      ),
    },
    {
      image: hostedPBX,
      title: "Integration Capabilities",
      content: (
        <ContentCard
          points={[
            "CRM integration to enhance customer interactions.",
            "Unified communications combining voice, video, and messaging.",
          ]}
        />
      ),
    },
    {
      image: hostedPBX,
      title: "Reliability & Security",
      content: (
        <ContentCard
          points={[
            "High uptime with redundant infrastructure for uninterrupted service.",
            "Data encryption & secure data centers for communication protection.",
          ]}
        />
      ),
    },
  ],
};
